import { Component, OnInit, OnDestroy, ViewChild, Output, EventEmitter, HostListener, ElementRef, Pipe,PipeTransform  } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { ConfirmationComponent } from "../../../components/common/confirmation/confirmation.component";
import { SubmitLoaderComponent } from "../../../components/common/submit-loader/submit-loader.component";
import { SuccessModalComponent } from '../../../components/common/success-modal/success-modal.component';
import { PresetsManageComponent } from 'src/app/components/common/presets-manage/presets-manage.component';
import { Constant, SolrContentTypeValues } from '../../../common/constant/constant';
import { ThreadPostService } from '../../../services/thread-post/thread-post.service';
import { CommonService } from '../../../services/common/common.service';
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { NgbModal, NgbModalConfig, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from 'moment';
import { Subscription } from "rxjs";
import { DomSanitizer } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { BaseService } from 'src/app/modules/base/base.service';
import { LandingpageService } from "../../../services/landingpage/landingpage.service";
import { ProductMatrixService } from '../../../services/product-matrix/product-matrix.service';
@Pipe({
  name: 'highlight'
})

export class HighlightSearchThreaddetail implements PipeTransform {
  transform(text: string, search: string): string {
    if (search && text) {
      let pattern = search.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      pattern = pattern.split(' ').filter((t) => {
        return t.length > 0;
      }).join('|');
      const regex = new RegExp(pattern, 'gi');
      return text.replace(regex, (match) => `<mark>${match}</mark>`);
    } else {
      return text;
    }
  }
}
@Component({
  selector: 'app-presets-list',
  templateUrl: './presets-list.component.html',
  styleUrls: ['./presets-list.component.scss'],
  providers: [MessageService]
})
export class PresetsListComponent implements OnInit, OnDestroy {
  @ViewChild('top',{static: false}) top: ElementRef;
  activeState: boolean[] = [true, false, false];
  @Output() presetActionEmit: EventEmitter<any> = new EventEmitter();
  @Output() presetActionPageEmit: EventEmitter<any> = new EventEmitter();
  public sconfig: PerfectScrollbarConfigInterface = {};
  public domainId;
  public userId;
  public countryId;
  public emptyFlag: boolean = false;
  public noResult: boolean = false;
  public loading: boolean = false;
  public innerHeight: number;
  public bodyHeight: number;
  public industryType: any = "";
  public contentType: number = 47;
  public displayOrder: number = 0;
  public pageAccess: string = 'presets';
  public user: any;
  public presetsData = [];
  public presetsListData: any =[];
  public offset: number = 0;
  public limit: number = 30;
  public scrollInit: number = 0;
  public lastScrollTop: number = 0;
  public scrollTop: number = 0;
  public scrollCallback: boolean = true;
  public itemLength: number = 0;
  public itemTotal: number = 0;
  public lazyLoading: boolean = false;
  subscription: Subscription = new Subscription();
  public modalConfig: any = {
    backdrop: "static",
    keyboard: false,
    centered: true,
  };
  public bodyClass: string = "submit-loader";
  public bodyElem;
  public successFlag: boolean = false;
  public successMsg: string = "";
  public searchValue: string = "";
  public manufacturerValue: string = "";
  public tagValue: string = "";
  public toHighlight;
  public facetsData: any = [];
  public presetshowPOPUPFlag: boolean = true;
  public tagList: any = [];
  public businessThirdpartyFlag: boolean = false;
  public CBADomain: boolean = false;
  // Resize Widow
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.bodyHeight = window.innerHeight;
    this.setScreenHeight();
  }

  // Scroll Down
  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    let inHeight = event.target.offsetHeight + event.target.scrollTop;
    let totalHeight = event.target.scrollHeight - (this.offset * 8);
    this.scrollTop = event.target.scrollTop - 80;
    console.log(this.scrollTop);
    console.log(this.lastScrollTop);
    console.log(this.scrollInit);
    if (this.scrollTop > this.lastScrollTop && this.scrollInit > 0) {
      console.log(inHeight);
      console.log(totalHeight);
      console.log(this.scrollCallback);
      console.log(this.itemTotal);
      console.log(this.itemLength);
      if (inHeight >= totalHeight && this.scrollCallback && this.itemTotal > this.itemLength) {
        this.lazyLoading = true;
        this.scrollCallback = false;
        this.presetsList(false,'');
      }
    }
    this.lastScrollTop = this.scrollTop;
  }

  constructor(
    private messageService: MessageService,
    private commonApi: CommonService,
    public activeModal: NgbActiveModal,
    private authenticationService: AuthenticationService,
    private threadPostService: ThreadPostService,
    private sanitizer: DomSanitizer,
    private modalService: NgbModal,
    private baseSerivce: BaseService,
    private LandingpagewidgetsAPI: LandingpageService,
    private probingApi: ProductMatrixService,
  ) { }

  ngOnInit(): void {
    
  this.bodyElem = document.getElementsByTagName('body')[0];
  this.bodyHeight = window.innerHeight;

	this.user = this.authenticationService.userValue;
	this.domainId = this.user.domain_id;
	this.userId = this.user.Userid;
	this.countryId = localStorage.getItem('countryId');

  this.industryType = this.commonApi.getIndustryType();
  let platformId1 = localStorage.getItem("platformId");
  this.CBADomain = (platformId1 == '3') ? true : false;
  let businessRole = localStorage.getItem('businessRole') != null ? localStorage.getItem('businessRole') : '' ;
  if(businessRole == '8' && platformId1=='3' && this.CBADomain)
  {
    this.businessThirdpartyFlag=true;
    
  }
 this.setScreenHeight();
 setTimeout(() => {  
 this.setScreenHeight();
 }, 2000);

 this.subscription.add(
  this.commonApi.presetsListDataReceivedSubject.subscribe((response) => {
    console.log(response);
    this.presetshowPOPUPFlag = response['presetshowPOPUP'] == '1' ? true : false;
    let flag = response['presetPushAction'];
    let presetAction = response['presetAction'];
    let id = response['presetId'];
    if(presetAction == 'visibile'){

    }
    else if(presetAction == 'search'){
      this.offset = 0;
      this.searchValue = response['searchValue'];
      this.manufacturerValue =  response['manufacturerValue'];
      this.tagValue =  response['tagValue'];
      this.presetsList(flag,id);
    }
    else{
      if(!flag){
        this.loading = true;
      }
      this.presetsList(flag,id);
    }

  })
  );

  }

  onTabClose(event) {
    this.messageService.add({severity:'info', summary:'Tab Closed', detail: 'Index: ' + event.index})
}

onTabOpen(event) {
    this.messageService.add({severity:'info', summary:'Tab Expanded', detail: 'Index: ' + event.index});
}

toggle(index: number) {
    this.activeState[index] = !this.activeState[index];
}


    // Set Screen Height
    setScreenHeight() {
      let headerHeight1 = (document.getElementsByClassName("head-brand")[0]) ? document.getElementsByClassName("head-brand")[0].clientHeight : 0;
      headerHeight1 = headerHeight1 + 20;
      this.bodyHeight = window.innerHeight;
      this.innerHeight = (this.bodyHeight - headerHeight1) - 148;
     }

  presetsList(pushFlag,id=''){

    if(this.offset == 0){
      this.presetsData = [];
      this.presetsListData = [];
      this.itemLength = 0;
      this.itemTotal = 0;
      this.lastScrollTop = -1 ;
    }
    
    //const apiFormData = new FormData();
    var objData = {};    
    let FiltersArr={};

    /*apiFormData.append('apiKey', Constant.ApiKey);
    apiFormData.append('domainId', this.domainId);
    apiFormData.append('countryId', this.countryId);
    apiFormData.append('userId', this.userId);*/

    FiltersArr["domainId"]=this.domainId;
    if(this.manufacturerValue != '' && this.manufacturerValue != undefined && this.manufacturerValue != null ){
      FiltersArr["manufacturer"]= this.manufacturerValue;
    }
    if(this.tagValue != '' && this.tagValue != undefined && this.tagValue != null ){
      FiltersArr["tagsStrArr"]= [this.tagValue];
    }
    objData["userId"]=this.userId;    
    objData["type"]= SolrContentTypeValues.Preset;    
    objData["listing"] = '1';
    objData["query"] = this.searchValue;
    this.toHighlight = this.searchValue;
    this.toHighlight=this.toHighlight.replaceAll(',',' ');
    this.toHighlight=this.toHighlight.trim();
    console.log(this.toHighlight);
    if(pushFlag){
      FiltersArr["presetIdInt"]=id;
      //apiFormData.append('presetId', id);
      objData["rows"]=1; 
      objData["start"]=0;
    }
    else{
      //apiFormData.append('offset', apiFormData["offset"]);
      //apiFormData.append('limit', apiFormData["limit"]);
      objData["rows"] = this.limit; 
      objData["start"] = this.offset;
    }
    objData["type"]=9;    
    objData["listing"] = '1';
    objData["filters"]=FiltersArr;
    let type =  this.searchValue == '' ?  'list' : 'search';
    //this.threadPostService.presetList(apiFormData).subscribe(res => {
    console.log(objData);
    //return false;

    this.commonApi.getPresetSolr(type, objData).subscribe(res => { 

      console.log(res);

      if(res.status=='Success'){

        let facets = res.facets;
          if(objData["rows"] > 1 && this.offset == 0 && !pushFlag) {
            Object.keys(facets).forEach(key => {
              switch (key) {
                case 'manufacturer':
                case 'make':
                case 'model':
                case 'year':
                case 'tagsJsonArr':
                case 'additionalInfo1':  
                  this.facetsData[key] = [];  
                  this.facetsData[key] = facets[key];
                  break;
              }
            });
            let data = {};
            data = {
              presetType: 'filteremit',
              facetsData: this.facetsData,
            };
            this.presetActionEmit.emit(data); 
            this.presetActionPageEmit.emit(data);
            
          }

          if(this.offset == 0 && !pushFlag && this.searchValue!='')
          {
            this.updateSearchKeyword(this.searchValue);
          }
          

          if(res.total == 0){
            if(this.offset == 0){
              this.loading = false;
              this.emptyFlag = pushFlag || this.searchValue!= '' || this.manufacturerValue!='' || this.tagValue!=''  ? false : true;
              this.noResult = true;
              this.presetsData = [];
              this.presetsListData = [];
              this.itemLength = 0;
              this.itemTotal = 0;
              this.lastScrollTop = -1 ;
            }
          }
          else{
            if(pushFlag){
              for(let i in this.presetsData){
                this.presetsData[i].listSelected = false;
              }
              let postAttachments = [];
              this.presetsListData = res.items;
              for (let i in this.presetsListData) {

                let editAccess = true;
                let deleteAccess = true;
                if(this.businessThirdpartyFlag){
                  editAccess = this.presetsListData[i].userId == this.userId ? true : false;
                  deleteAccess =  this.presetsListData[i].userId == this.userId ? true : false;
                }  
                this.presetsListData[i].editAccess = editAccess;
                this.presetsListData[i].deleteAccess = deleteAccess;
                this.presetsListData[i].id = this.presetsListData[i].presetIdInt;
                let tagItems = this.presetsListData[i].tagsJsonArr;
                let nameArr = [];
                if(tagItems && tagItems.length>0){
                  for (let t in tagItems) {
                    nameArr.push(tagItems[t].name);
                  }   
                  this.presetsListData[i].tagList = nameArr;              
                }
                else{                  
                  this.presetsListData[i].tagList = nameArr;
                }

              let manufacturerName = '';
              let manufacturer = [];
              var mfgJSON = this.testJSON(this.presetsListData[i].manufacturer);
              if(mfgJSON){
                manufacturer = JSON.parse(this.presetsListData[i].manufacturer);
                if(manufacturer.length>0){
                  for(let mfg of manufacturer) {
                  manufacturerName = mfg.name;
                  }
                }
              }
              else{
                manufacturerName = (this.presetsListData[i].manufacturer);
              }
              
              this.presetsListData[i].manufacturerName = manufacturerName;

                let make = [];
                let makeName = '';
                var makeJSON = this.testJSON(this.presetsListData[i].make);
                if(makeJSON){
                  make = JSON.parse(this.presetsListData[i].make);
                  for(let m of make) {
                    makeName = m.name;
                  }
                }
                else{
                  makeName = this.presetsListData[i].make;
                }
                this.presetsListData[i].makeName = makeName;

                this.presetsListData[i].modelName = this.presetsListData[i].model;

                let data1 = this.presetsListData[i].manufacturerName == '' || this.presetsListData[i].manufacturerName == 'NA' ? '' : this.presetsListData[i].manufacturerName;
                let data2 = this.presetsListData[i].makeName == '' || this.presetsListData[i].makeName == 'NA' ? '' : this.presetsListData[i].makeName;
                let data3 = this.presetsListData[i].modelName == '' || this.presetsListData[i].modelName == 'NA' ? '' : this.presetsListData[i].modelName;
                let data4 = this.presetsListData[i].year == 'null' || this.presetsListData[i].year == null || this.presetsListData[i].year == undefined ? '' : this.presetsListData[i].year;

                let chevron = "<img src='assets/images/preset/preset-chevron.png'>";
                let data1check = '';
                let data2check = '';
                if(this.industryType.id == 2) {
                  data1check = data1 == '' ? '' : data1;
                  data2check = data2 == '' ? data1check : data1check+"&nbsp;"+chevron+ "&nbsp;"+data2;
                }
                else{
                  data2check = data2 == '' ? '' : data2;
                }
                let data3check = data3 == '' ? data2check : data2check+"&nbsp;"+chevron+ "&nbsp;"+data3;
                let data4check = data4 == '' ? data3check : data3check+"&nbsp;"+chevron+ "&nbsp;"+data4;

                if(this.industryType.id == 2) {
                  this.presetsListData[i].titleMakeModelYear = this.presetsListData[i].threadTitle+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"+data4check;
                  this.presetsListData[i].titleMakeModelYearPH = this.presetsListData[i].threadTitle+", "+data1+" > "+data2+" > "+data3+" > "+data4;

                }
                else{
                  this.presetsListData[i].titleMakeModelYear = this.presetsListData[i].threadTitle+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"+data4check;
                  this.presetsListData[i].titleMakeModelYearPH = this.presetsListData[i].threadTitle+", "+data2+" > "+data3+" > "+data4;

                }
                this.presetsListData[i].contentEmit = this.presetsListData[i].content;
                this.presetsListData[i].listSelected = true;
                this.presetsListData[i].isSelected = true;


                let contentWeb = '';
                contentWeb = this.authenticationService.convertunicode(this.authenticationService.ChatUCode(this.presetsListData[i].content));
                this.presetsListData[i].content = this.sanitizer.bypassSecurityTrustHtml(this.authenticationService.URLReplacer(contentWeb));


                this.presetsListData[i].action = 'view';
                this.presetsListData[i].attachments = [];
                this.presetsListData[i].attachmentLoading = false;

                if(this.presetsListData[i].uploadContents){
                  this.presetsListData[i].attachments = this.presetsListData[i].uploadContents;
                  this.presetsListData[i].attachmentLoading = (this.presetsListData[i].uploadContents.length>0) ? false : true;
                  postAttachments.push({
                    id: this.presetsListData[i].presetIdInt,
                    attachments: this.presetsListData[i].uploadContents
                  });
                }

                let date1 = this.presetsListData[i].createdOnNew;
                let date2 = moment.utc(date1).toDate();
                this.presetsListData[i].createdDate = moment(date2).local().format('MMM DD, YYYY . h:mm A');

                let tIndex = this.presetsData.findIndex(option => option.presetIdInt == id);
                if(tIndex < 0){
                  this.presetsData.unshift(this.presetsListData[i]);
                  this.top.nativeElement.scrollTop = 0;
                }
                else{
                  this.presetsData[tIndex] = this.presetsListData[i];
                  //this.presetsListData[tIndex].listSelected = true;
                }
                console.log(this.presetsData);
                this.loading = false;
                this.emptyFlag = false;
                this.noResult = false;
              }
              let threadPostStorageText = `presetsAttachments`;
              localStorage.setItem(threadPostStorageText, JSON.stringify(postAttachments));
            }
            else{
              
              this.presetsListData = res.items;
              let postAttachments = [];
              for (let i in this.presetsListData) {
                let editAccess = true;
                let deleteAccess = true;
                if(this.businessThirdpartyFlag){
                  editAccess = this.presetsListData[i].userId == this.userId ? true : false;
                  deleteAccess =  this.presetsListData[i].userId == this.userId ? true : false;
                }               

                this.presetsListData[i].editAccess = editAccess;
                this.presetsListData[i].deleteAccess = deleteAccess;
                this.presetsListData[i].id = this.presetsListData[i].presetIdInt;
                let tagItems = this.presetsListData[i].tagsJsonArr;
                let nameArr = [];
                if(tagItems && tagItems.length>0){
                  for (let t in tagItems) {
                    nameArr.push(tagItems[t].name);
                  }   
                  this.presetsListData[i].tagList = nameArr;              
                }
                else{                  
                  this.presetsListData[i].tagList = nameArr;
                }                
                let manufacturerName = '';
                let manufacturer = [];
                var mfgJSON = this.testJSON(this.presetsListData[i].manufacturer);
                if(mfgJSON){
                  manufacturer = JSON.parse(this.presetsListData[i].manufacturer);
                  if(manufacturer.length>0){
                    for(let mfg of manufacturer) {
                    manufacturerName = mfg.name;
                    }
                  }
                }
                else{
                  manufacturerName = (this.presetsListData[i].manufacturer);
                }
              
              this.presetsListData[i].manufacturerName = manufacturerName;

                let make = [];
                let makeName = '';
                var makeJSON = this.testJSON(this.presetsListData[i].make);
                if(makeJSON){
                  make = JSON.parse(this.presetsListData[i].make);
                  for(let m of make) {
                    makeName = m.name;
                  }
                }
                else{
                  makeName = this.presetsListData[i].make.trim();
                }
                this.presetsListData[i].makeName = makeName;

                this.presetsListData[i].modelName = this.presetsListData[i].model.trim();

                let data1 = this.presetsListData[i].manufacturerName == '' || this.presetsListData[i].manufacturerName == 'NA' ? '' : this.presetsListData[i].manufacturerName;
                let data2 = this.presetsListData[i].makeName == '' || this.presetsListData[i].makeName == 'NA' ? '' : this.presetsListData[i].makeName;
                let data3 = this.presetsListData[i].modelName == '' || this.presetsListData[i].modelName == 'NA' ? '' : this.presetsListData[i].modelName;
                let data4 = this.presetsListData[i].year == 'null' || this.presetsListData[i].year == null || this.presetsListData[i].year == undefined ? '' : this.presetsListData[i].year;

                let chevron = "<img src='assets/images/preset/preset-chevron.png'>";
                let data1check = '';
                let data2check = '';
                if(this.industryType.id == 2) {
                  data1check = data1 == '' ? '' : data1;
                  data2check = data2 == '' ? data1check : data1check+"&nbsp;"+chevron+ "&nbsp;"+data2;
                }
                else{
                  data2check = data2 == '' ? '' : data2;
                }
                let data3check = data3 == '' ? data2check : data2check+"&nbsp;"+chevron+ "&nbsp;"+data3;
                let data4check = data4 == '' ? data3check : data3check+"&nbsp;"+chevron+ "&nbsp;"+data4;

                if(this.industryType.id == 2) {
                  this.presetsListData[i].titleMakeModelYear = this.presetsListData[i].threadTitle+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"+data4check;
                  this.presetsListData[i].titleMakeModelYearPH = this.presetsListData[i].threadTitle+", "+data1+" > "+data2+" > "+data3+" > "+data4;

                }
                else{
                  this.presetsListData[i].titleMakeModelYear = this.presetsListData[i].threadTitle+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"+data4check;
                  this.presetsListData[i].titleMakeModelYearPH = this.presetsListData[i].threadTitle+", "+data2+" > "+data3+" > "+data4;

                }

                this.presetsListData[i].contentEmit = this.presetsListData[i].content;
                this.presetsListData[i].listSelected = false;
                this.presetsListData[i].isSelected = false;


                let contentWeb = '';
                contentWeb = this.authenticationService.convertunicode(this.authenticationService.ChatUCode(this.presetsListData[i].content));
                this.presetsListData[i].content = this.sanitizer.bypassSecurityTrustHtml(this.authenticationService.URLReplacer(contentWeb));


                this.presetsListData[i].action = 'view';
                this.presetsListData[i].attachments = [];
                this.presetsListData[i].attachmentLoading = false;

                if(this.presetsListData[i].uploadContents){
                  this.presetsListData[i].attachments = this.presetsListData[i].uploadContents;
                  this.presetsListData[i].attachmentLoading = (this.presetsListData[i].uploadContents.length>0) ? false : true;
                  postAttachments.push({
                    id: this.presetsListData[i].id,
                    attachments: this.presetsListData[i].uploadContents
                  });
                }

                let date1 = this.presetsListData[i].createdOnNew;
                let date2 = moment.utc(date1).toDate();
                this.presetsListData[i].createdDate = moment(date2).local().format('MMM DD, YYYY . h:mm A');

                this.presetsData.push(this.presetsListData[i]);

                setTimeout(() => {
                  let tIndex = this.presetsData.findIndex(option => option.id == id);
                  if(tIndex < 0){}
                  else{
                    this.presetsListData[tIndex].listSelected = true;
                    this.presetsListData[tIndex].isSelected = true;
                  }
                }, 700);

                this.loading = false;
                this.emptyFlag = false;
                this.noResult = false;
                this.lazyLoading = false;

              }
              let threadPostStorageText = `presetsAttachments`;
              localStorage.setItem(threadPostStorageText, JSON.stringify(postAttachments));

              this.scrollCallback = true;
              this.scrollInit = 1;
              this.itemTotal = res.total;
              this.itemLength += this.presetsData.length;
              this.offset += this.limit;

            }
          }
      }
      else{

      }

    },
    (error => {})
    );

  }

  testJSON(text){
    if (typeof text!=="string"){
        return false;
    }
    try{
        var json = JSON.parse(text);
        return (typeof json === 'object');
    }
    catch (error){
        return false;
    }
  }

  openPresetsAction(type,id){
    if(this.presetshowPOPUPFlag){
      let data = {};
      if(type == 'emit'){
        data = {
          presetType: 'emit',
          presetData: id,
        };
      }
      else{
        data = {
          presetType: type,
          presetPushAction: false,
          presetId: id,
        };
      }
      this.presetActionEmit.emit(data);      
    }
    else{
      this.openPresetPOPUP(type,id);
    }
  }

  openPresetPOPUP(type,id){
    this.bodyElem.classList.add("presets-popup");
    const modalRef = this.modalService.open(PresetsManageComponent, {backdrop: 'static', keyboard: false, centered: true});
    modalRef.componentInstance.presetType = type;
    modalRef.componentInstance.presetId = id;
    modalRef.componentInstance.presetshowPOPUP = this.presetshowPOPUPFlag;    
    modalRef.componentInstance.presetsServices.subscribe((receivedService) => {
      console.log(receivedService.action) ;
      this.bodyElem.classList.remove("presets-popup");
      modalRef.dismiss('Cross click');
    });  
  }
  selectedActive(index){
    for(let i in this.presetsData){
      this.presetsData[i].listSelected = false;
      //this.presetsData[i].isSelected = false;
    }
    this.presetsData[index].listSelected = true;
    //this.presetsData[index].isSelected = true;
  }
 
    // Delete 
    deletePresetsAction(pid) {
      const modalRef = this.modalService.open(
        ConfirmationComponent,
        this.modalConfig
      );
      modalRef.componentInstance.access = "Delete";
      modalRef.componentInstance.confirmAction.subscribe((receivedService) => {
        modalRef.dismiss("Cross click");
        if (receivedService) {
          this.bodyElem.classList.add(this.bodyClass);
          const submitModalRef = this.modalService.open(
            SubmitLoaderComponent,
            this.modalConfig
          );
          const apiFormData = new FormData();
          apiFormData.append('apiKey', Constant.ApiKey);
          apiFormData.append('domainId', this.domainId);
          apiFormData.append('countryId', this.countryId);
          apiFormData.append('userId', this.userId);
          apiFormData.append('presetId', pid);
        
          this.threadPostService.deletePreset(apiFormData).subscribe((response) => {
            submitModalRef.dismiss("Cross click");
            this.bodyElem.classList.remove(this.bodyClass);
            this.successMsg = response.result;
            const msgModalRef = this.modalService.open(
              SuccessModalComponent,
              this.modalConfig
            );
            msgModalRef.componentInstance.successMessage = this.successMsg;
            let apiDatasocial = new FormData();
            apiDatasocial.append('apiKey', Constant.ApiKey);
            apiDatasocial.append('domainId', this.domainId);
            apiDatasocial.append('userId', this.userId);
            apiDatasocial.append('action', 'delete');
            apiDatasocial.append('actionType', SolrContentTypeValues.Preset.toString());
            apiDatasocial.append('threadId', pid);
            
            /*new Response(apiDatasocial).text().then(console.log)
            return false;*/

            this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => { });
            setTimeout(() => {
              msgModalRef.dismiss("Cross click");
              this.successMsg = "";
              let partIndex = this.presetsData.findIndex(option => option.presetIdInt == pid);
              this.presetsData.splice(partIndex, 1);
            }, 2000);
          });
        }
      });
    }

    updateSearchKeyword(keyword)
    {
      const apiFormData = new FormData();
      apiFormData.append("apiKey", Constant.ApiKey);
      apiFormData.append("domainId", this.domainId);
      apiFormData.append("keyword", keyword);
      apiFormData.append("userId", this.userId);
      this.LandingpagewidgetsAPI.apiUpdateSearchKeyword(apiFormData).subscribe((response) => {});
    }

    hideallToooltips(){
      let elem3: any= '';
      elem3 = document.getElementsByTagName('ngb-tooltip-window');
      if(elem3 && elem3.length>0 ){
        console.log(1)
        elem3[0].classList.remove("show");
      }
    }
    getUserProfileStatus(uid,index) {
      let elem: any= '';
      let elem1: any= '';
      let ariadescribedby: any ='';
      elem = document.getElementById('ngbTooltip'+index);
      if(elem){
        ariadescribedby = elem.getAttribute("aria-describedby");
        elem1 = document.getElementById(ariadescribedby);
        if(elem1){
          if(!elem1.classList.contains("show")){
            console.log(2)
            !elem1.classList.add("show");
          };
        }
      }
      const apiFormData = new FormData();
      apiFormData.append('apiKey', Constant.ApiKey);
      apiFormData.append('domainId', this.domainId);
      apiFormData.append('countryId', this.countryId);
      apiFormData.append('userId', uid);
      this.probingApi.GetUserAvailability(apiFormData).subscribe((response) => {
        let resultData = response.items;
        let availability = resultData.availability;
        let availabilityStatusName = resultData.availabilityStatusName;
        let badgeTopUser = resultData.badgeTopUser;
        this.presetsData[index].availability = availability;
        this.presetsData[index].availabilityStatusName = availabilityStatusName;
        this.presetsData[index].profileShow = true;
      });
    }
      // tab on user profile page
      taponprofileclick(userId){
        var aurl='profile/'+userId+'';
        window.open(aurl, aurl);
      }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }


}
